export default "//cloud.imgsmail.ru/cloud.mail.ru/171758/img/build/overquotaMobile.png";